import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b13033"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asDocuments" }
const _hoisted_2 = { class: "asDocuments_title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_external_document = _resolveComponent("as-external-document")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
      return (_openBlock(), _createBlock(_component_as_external_document, {
        key: doc.id,
        doc: doc
      }, null, 8, ["doc"]))
    }), 128)),
    _createVNode(_component_as_external_document, {
      doc: {
        url: _ctx.instructionUrl,
        title: _ctx.$t('userInstruction')
      },
      "is-modal": true
    }, null, 8, ["doc"])
  ]))
}